export class ChangeLogEntry {
    public constructor(public timeStamp: Date, public message: string) {}
  }
